import { useEffect, useState } from "react";
import { api } from "../lib/api";

// Module-level cache so we don't hit /settings on every page render
let cachedName = null;
const listeners = new Set();

const setName = (name) => {
  cachedName = name;
  listeners.forEach((l) => l(name));
};

export default function PageHeader({ title, subtitle, actions }) {
  const [homestayName, setHomestayName] = useState(cachedName);

  useEffect(() => {
    const listener = (n) => setHomestayName(n);
    listeners.add(listener);
    if (cachedName === null) {
      api.get("/settings")
        .then((r) => setName(r.data?.homestay_name || ""))
        .catch(() => setName(""));
    }
    return () => listeners.delete(listener);
  }, []);

  const breadcrumb = homestayName ? `PondokRaja · ${homestayName}` : "PondokRaja";

  return (
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D16B4D] mb-2">
          {breadcrumb}
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium text-[#172E21] tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-[#586D61] mt-2 text-sm sm:text-base max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-3 flex-wrap">{actions}</div>}
    </div>
  );
}

// Expose cache-reset for logout flow (optional)
export const resetHomestayNameCache = () => { cachedName = null; };
